import type { TooltipItem } from '@/app/common/api/types/tooltipsApiTypes';
import { FiCheckCircle as CheckCircle2 } from 'react-icons/fi';
import { buildTooltipHtml } from '../utils/tooltipContent';
import type { ComparisonFeature, FeatureHint, FeaturePlanKey } from '../types';

export function getFeatureHint(
  feature: ComparisonFeature,
  tooltipItem?: TooltipItem,
): FeatureHint {
  const baseHint =
    feature.hint || {
      type: 'text',
      description: '',
    };
  const apiDescription = tooltipItem ? buildTooltipHtml(tooltipItem) : null;

  if (apiDescription) {
    return {
      ...baseHint,
      description: apiDescription,
    };
  }

  return baseHint;
}

export function getFeaturePlanValue(
  feature: ComparisonFeature,
  plan: FeaturePlanKey,
) {
  const value = feature[plan];

  if (value === 'active') {
    return <CheckCircle2 className="feature-check" size={16} />;
  }

  return value;
}
